var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassengers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6461 2C18.3225 2 19.6817 3.50311 19.6817 5.35703C19.6817 7.21095 18.3225 8.71405 16.6461 8.71405C14.9698 8.71405 13.6106 7.21095 13.6106 5.35703C13.6106 3.50311 14.9698 2 16.6461 2Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33079 2C10.312 2 11.9182 3.7764 11.9182 5.9674C11.9182 8.15839 10.312 9.93479 8.33079 9.93479C6.34962 9.93479 4.74334 8.15839 4.74334 5.9674C4.74334 3.7764 6.34962 2 8.33079 2Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0919 20H4.56971C3.1505 20 2 18.8851 2 17.5097C2.0002 13.665 4.22788 11.2411 8.33079 11.2411C12.0274 11.2411 14.6617 13.665 14.6616 17.5097C14.6616 18.8851 13.5111 20 12.0919 20Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0863 17.2311H19.8262C21.0268 17.2311 22 16.2879 22 15.1245C22.0001 11.8721 19.7717 9.82166 16.6446 9.82166C15.0062 9.82166 13.7213 10.2786 12.8212 11.1031C14.9205 12.4602 16.0162 14.8197 16.0863 17.2311Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassengers);
export default __webpack_public_path__ + "static/media/passengers.f01d91355eb2c633544bba7a7376f738.svg";
export { ForwardRef as ReactComponent };